import { Observable } from "rxjs";
import { TipoIdentificacion } from "../entity/tipo-identificacion.model";







import { MotivosNoAdmision } from '../entity/motivos-no-admision.model';

import { Ciudad } from '../entity/ciudad.model';
import { Municipio } from '../entity/municipio.model';
import { PlanSalud } from '../entity/plan-salud.model';
import { TipoAtencion } from '../entity/tipos-atencion.model';

import { HttpParams } from "@angular/common/http";
import { ConfiguracionInferirPiso } from '../entity/configuracion-inferir-piso.model';
import { ConfiguracionInferirSLA } from '../entity/inferir-sla.model';
import { Piso } from '../entity/piso.model';
import { Programa } from '../entity/programa.model';
import { TipoConvenio } from '../entity/tipo-convenio.model';

import { Conducta } from "../../no-hospitalario/solicitud/entity/conducta.model";
import { ConfiguracionInferirConvenio } from '../entity/configuracion-inferir-convenio.model';
import { TipoPrestacion } from "../entity/tipo-prestacion.model";
import { Zona } from '../entity/zona.model';



export abstract class MaestrosGateway {
    abstract consultarTiposIdentificacion(): Observable<TipoIdentificacion[]>;

    abstract consultarConfiguracionConvenio(idTipoAtencion: number, planContrato: string, anexoAtencionDomiciliaria: boolean): Observable<ConfiguracionInferirConvenio>;

    abstract consultarPlanesSalud(): Observable<PlanSalud[]>;

    abstract consultarCiudades(): Observable<Ciudad[]>;

    abstract consultarMunicipios(idCiudad: string): Observable<Municipio[]>;

    abstract consultarTipoAtencionPorCodigo(codigoTipo: number): Observable<TipoAtencion[]>;

    abstract consultarTipoPrestacionPorServicio(tipoServicio: number): Observable<TipoPrestacion[]>;

    abstract consultarPisoPorCiudadProgramaPrestacion(idCiudad: string, idPrograma: string, idTipoPrestacion: string): Observable<ConfiguracionInferirPiso>;

    abstract consultarZonasPorPiso(idPiso: string): Observable<Zona[]>;

    abstract consultarPisoPorId(idPiso: string): Observable<Piso>;

    abstract consultarConductaPorId(idConducta: string): Observable<Conducta>;

    abstract consultarSlaPorPlanSaludPrestacion(idPlanSalud: string, idTipoPrestacion: string): Observable<ConfiguracionInferirSLA[]>;

    abstract consultarTipoConvenios(): Observable<TipoConvenio[]>;

    abstract consultarProgramas(): Observable<Programa[]>

    abstract consultarMotivoCancelacion(): Observable<MotivosNoAdmision[]>;

    abstract consultarInferirCopago(plan: string, codigoTipoAtencion: number): Observable<number>;

    abstract get<T>(endpoint: string, params?: HttpParams): Observable<T>;

    abstract consultarMotivosNoAdmision(idAtencion: number): Observable<MotivosNoAdmision[]>
    abstract getTipoAtencionPorCodigo(codigoTipo: number): Observable<TipoAtencion[]>;

}
